module.exports = __webpack_public_path__ + "static/media/dynamic_iiot_1.083b6bff.png";